import { useCallback, useEffect, useState } from 'react'
import { getPrompts, type UserPrompt } from '@/services/prompt-library-service'
import { logError } from '@/lib/logger'

const CHANGED_EVENT = 'user-prompts-changed'

/** Widget and panel show the same list; a change in one reloads the other. */
export const notifyPromptsChanged = () => window.dispatchEvent(new CustomEvent(CHANGED_EVENT))

export function usePromptList(enabled = true) {
  const [prompts, setPrompts] = useState<UserPrompt[]>([])
  const [loading, setLoading] = useState(enabled)
  const [failed, setFailed] = useState(false)

  const load = useCallback(async () => {
    try {
      setPrompts(await getPrompts())
      setFailed(false)
    } catch (error) {
      logError(error instanceof Error ? error : new Error(String(error)), { context: 'usePromptList.load' })
      setFailed(true)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (!enabled) return
    void load()
    window.addEventListener(CHANGED_EVENT, load)
    return () => window.removeEventListener(CHANGED_EVENT, load)
  }, [enabled, load])

  return { prompts, setPrompts, loading, failed, reload: load }
}
